import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router';

import { Spin } from 'antd';

import CLIENT from '../modules/client/actionTypes';

import { ReduxState } from '../types/app';

const ProtectedRoute = () => {
  const location = useLocation();
  const { isLoggedIn, loadReadyStatus } = useSelector(
    (state: ReduxState) => state.Client
  );

  const isAuthCheckPending =
    loadReadyStatus === CLIENT.LOAD.INVALID ||
    loadReadyStatus === CLIENT.LOAD.REQUESTING;

  if (isAuthCheckPending) {
    return (
      <div className="protected-route-loader">
        <Spin size="large" />
      </div>
    );
  }

  if (!isLoggedIn) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
